import { RiArrowRightLine } from '@remixicon/react'
import { Menu } from 'lucide-react'
import { NavLink, Outlet, useLocation } from 'react-router'

import { Logo } from '#app/components/logo.tsx'
import { Button } from '#app/components/ui/button.tsx'
import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuItem,
	DropdownMenuTrigger,
} from '#app/components/ui/dropdown-menu.tsx'
import { cn } from '#app/utils/misc.tsx'

export default function MocraShellLayout() {
	const location = useLocation()
	const isSectionRoute =
		location.pathname.startsWith('/mocra/overview') ||
		/^\/mocra\/61[0-2]/.test(location.pathname) ||
		/^\/mocra\/60[5-9]/.test(location.pathname)

	const navItems = [
		{
			key: 'form',
			to: '/mocra/get-started',
			label: 'MoCRA SOP Builder',
			description: 'Become MoCRA compliant.',
			active: !isSectionRoute,
		},
		{
			key: 'sections',
			to: '/mocra/overview',
			label: 'MoCRA Guide',
			description: 'Learn about MoCRA statutes.',
			active: isSectionRoute,
		},
	] as const

	return (
		<div className="bg-background min-h-screen">
			<header className="border-border/80 bg-background/95 sticky top-0 z-50 border-b backdrop-blur">
				<div className="mx-auto flex w-full max-w-6xl items-center justify-between gap-4 px-4 py-4">
					<NavLink to="/" className="flex items-center gap-2">
						<Logo className="h-5 w-5" />
						<span className="text-xs font-semibold tracking-widest uppercase">
							Lydra AI
						</span>
					</NavLink>
					<DropdownMenu>
						<DropdownMenuTrigger asChild>
							<Button
								variant="ghost"
								size="icon"
								className="text-muted-foreground hover:text-foreground"
								aria-label="Open MoCRA navigation"
							>
								<Menu className="h-4 w-4" />
							</Button>
						</DropdownMenuTrigger>
						<DropdownMenuContent align="end" className="min-w-[240px]">
							{navItems.map((item) => (
								<DropdownMenuItem
									asChild
									key={item.key}
									className={cn(
										'px-3 py-2',
										item.active && 'bg-primary/10 text-primary',
									)}
								>
									<NavLink
										to={item.to}
										className="flex w-full items-center gap-3 text-left"
									>
										<div className="flex-1">
											<p className="text-xs font-semibold tracking-wide uppercase">
												{item.label}
											</p>
											<p className="text-muted-foreground text-[11px]">
												{item.description}
											</p>
										</div>
										<RiArrowRightLine className="text-muted-foreground h-4 w-4" />
									</NavLink>
								</DropdownMenuItem>
							))}
						</DropdownMenuContent>
					</DropdownMenu>
				</div>
			</header>
			<main className="mx-auto w-full max-w-6xl px-4 pt-10 pb-20">
				<Outlet />
			</main>
		</div>
	)
}
